import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { ClienteTipoFiscal, clienteTiposFiscais } from '../cliente-tipo-fiscal';

@Component({
    selector: 'sgt-cliente-tipo-fiscal-select',
    templateUrl: './cliente-tipo-fiscal-select.component.html',
    styleUrls: ['./cliente-tipo-fiscal-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ClienteTipoFiscalSelectComponent), multi: true },
    ]
})
export class ClienteTipoFiscalSelectComponent {
    /** ID do tipo fiscal selecionado */
    @Input() ngModel: number;
    /** Ao alterar o tipo fiscal selecionado */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Tipo Fiscal */
    @Input() tipoFiscal: ClienteTipoFiscal;
    @Output() tipoFiscalChange = new EventEmitter<ClienteTipoFiscal>();


    tipos = clienteTiposFiscais;

    /**
     * Nome do select
     */
     @Input() name: string;
    /**
     * ID do select
     */
    @Input() id: string;
    /**
     * Se a região é obrigatória
     */
     @Input() required: any;
    /**
     * Se deve desabilitar o select
     */
     @Input() disabled: any;
    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;
    /** Label para a opção de selecionar a opção nula */
    @Input() nullLabel = 'NENHUM TIPO FISCAL'

    propagateChange: any = () => {};

    /** Ao alterar o tipo fiscal */
    onChange(idTipoFiscal: number) {
        this.ngModel = idTipoFiscal;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);

        this.tipoFiscal = this.tipos?.find(recursoFilter => recursoFilter.id === idTipoFiscal);
        this.tipoFiscalChange.emit(this.tipoFiscal);
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
